import { StringEnum, Type } from "@feathersjs/typebox";
import { artccIdSchema } from "../events.js";
export const SsoUserApiInfo = Type.Object({
    id: Type.Number(),
    fname: Type.String(),
    lname: Type.String(),
    uname: Type.String(),
    email: Type.String({ format: "email" }),
    groups: Type.String(),
    image: Type.String(),
    verified: Type.Boolean(),
    createdon: Type.String(),
});
export const SsoUserApiInfoRestricted = Type.Omit(SsoUserApiInfo, [
    "fname",
    "lname",
    "email",
    "groups",
    "verified",
]);
const atcAuthorizationScopes = ["ALL", "ARTCC", "FACILITY", "AREA", "POSITION"];
const controllerAuthorizations = Type.Object({
    scope: StringEnum(atcAuthorizationScopes),
    artccId: artccIdSchema,
    facility: Type.Optional(Type.String({ maxLength: 5 })),
    sectorId: Type.Optional(Type.String()),
    area: Type.Optional(Type.String()),
});
export const userDbInfo = Type.Object({
    userid: Type.String(),
    lastLogin: Type.Optional(Type.String()),
    birthday: Type.Optional(Type.String()),
    controllerAuthorizations: Type.Optional(Type.Array(controllerAuthorizations)),
});
export const stratusUserInfo = Type.Object({
    dbInfo: Type.Optional(userDbInfo),
    ssoInfo: Type.Union([SsoUserApiInfo, SsoUserApiInfoRestricted]),
});
//# sourceMappingURL=user.js.map